import { useContext, useEffect, useMemo, useState } from 'react'

import { autorun } from 'mobx'
import { MobXProviderContext } from 'mobx-react'

import WeatherUnits, {
  temperatureUnits,
} from '~/client/src/shared/enums/WeatherUnits'
import { IResourceRuntimeContext } from '~/client/src/shared/resources/definitions'

interface IWeatherContext {
  weatherForecastsStore?: {
    weatherUnits?: WeatherUnits
  }
}

const resolveTemperatureUnit = (
  store?: IWeatherContext['weatherForecastsStore'],
) => temperatureUnits(store?.weatherUnits || WeatherUnits.Metric)

export function useResourceRuntimeContext(): IResourceRuntimeContext {
  const { weatherForecastsStore } = useContext(
    MobXProviderContext,
  ) as IWeatherContext

  const [temperatureUnit, setTemperatureUnit] = useState(() =>
    resolveTemperatureUnit(weatherForecastsStore),
  )

  useEffect(
    () =>
      autorun(() =>
        setTemperatureUnit(resolveTemperatureUnit(weatherForecastsStore)),
      ),
    [weatherForecastsStore],
  )

  return useMemo(() => ({ temperatureUnit }), [temperatureUnit])
}
